import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

/**
 * Rule for when the kicking team recovers a bar ball (Indoor Football).
 * A bar ball is when a kickoff hits the goalpost. If the kicking team recovers,
 * they retain possession at the recovery spot.
 */
export default class BarBallRecoveredKicking extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.BarBallRecoveredKicking
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { recoveredBy, recoveredAt } = fragment;

        // Kicking team retains possession
        if (recoveredBy) {
            gameContext.setCurrentPlayerInPossession(recoveredBy);
        }
        if (recoveredAt || recoveredAt === 0) {
            gameContext.setFieldPosition(recoveredAt);
        }
        ruleContext.setAwardFirstDown(true);
    }
}
